import { isApplicationNonProd } from '../../helpers';

export const KAMELEOON_GOALS = {
  CLICK_THROUGH_RATE: 'CLICK_THROUGH_RATE',
  CONFIRM_SALE_BUTTON_CLICKED: 'CONFIRM_SALE_BUTTON_CLICKED',
  ENQUIRY_CREATED: 'ENQUIRY_CREATED',
  MILEAGE_ENTERED: 'MILEAGE_ENTERED',
  MOTORWAY_LOGO_CLICKED: 'MOTORWAY_LOGO_CLICKED',
  OFFER_SELECT_RATE: 'OFFER_SELECT_RATE',
  VRM_SUBMITTED: 'VRM_SUBMITTED',
} as const;

export const KAMELEOON_GOALS_STAGE = {
  [KAMELEOON_GOALS.CLICK_THROUGH_RATE]: 320907,
  [KAMELEOON_GOALS.ENQUIRY_CREATED]: 314514,
  [KAMELEOON_GOALS.MILEAGE_ENTERED]: 318577,
  [KAMELEOON_GOALS.MOTORWAY_LOGO_CLICKED]: 314510,
  [KAMELEOON_GOALS.OFFER_SELECT_RATE]: 318578,
  [KAMELEOON_GOALS.VRM_SUBMITTED]: 315484,
  [KAMELEOON_GOALS.CONFIRM_SALE_BUTTON_CLICKED]: 323007,
} as const;

export const KAMELEOON_GOALS_PROD = {
  [KAMELEOON_GOALS.CLICK_THROUGH_RATE]: 320908,
  [KAMELEOON_GOALS.ENQUIRY_CREATED]: 317568,
  [KAMELEOON_GOALS.MILEAGE_ENTERED]: 318576,
  [KAMELEOON_GOALS.MOTORWAY_LOGO_CLICKED]: 317589,
  [KAMELEOON_GOALS.OFFER_SELECT_RATE]: 318579,
  [KAMELEOON_GOALS.VRM_SUBMITTED]: 317567,
  [KAMELEOON_GOALS.CONFIRM_SALE_BUTTON_CLICKED]: 323008,
} as const;

type KAMELEOON_GOAL_PROD_KEYS = keyof typeof KAMELEOON_GOALS_PROD;
type KAMELEOON_GOAL_STAGE_KEYS = keyof typeof KAMELEOON_GOALS_STAGE;
export type KAMELEOON_GOAL_KEYS = KAMELEOON_GOAL_PROD_KEYS | KAMELEOON_GOAL_STAGE_KEYS;

export const processKameleoonConversion = (kameleoonGoalName: KAMELEOON_GOAL_KEYS) => {
  const goal = isApplicationNonProd ? KAMELEOON_GOALS_STAGE : KAMELEOON_GOALS_PROD;
  const goalId = goal[kameleoonGoalName];

  if (goalId) {
    window?.kameleoonQueue?.push(['Goals.processConversion', goalId]);
  }
};
